import React from 'react';

export const TourMockCapture: React.FC = () => {
  return (
    <div className="w-full bg-white rounded-xl border border-border shadow-lg overflow-hidden flex flex-col aspect-video">
      <div className="bg-subtle border-b border-border px-4 py-3 flex items-center gap-2">
        <div className="flex gap-1.5">
          <div className="w-2.5 h-2.5 rounded-full bg-red-400"></div>
          <div className="w-2.5 h-2.5 rounded-full bg-amber-400"></div>
          <div className="w-2.5 h-2.5 rounded-full bg-green-400"></div>
        </div>
        <div className="ml-4 w-32 h-2 rounded-full bg-border/50"></div>
      </div>
      
      <div className="p-6 flex-1 font-mono text-sm leading-relaxed text-ink/80 relative">
        <div className="absolute top-6 left-6 w-0.5 h-5 bg-primary animate-pulse"></div>
        <p className="mb-2 text-muted">Reunião de Planejamento Q3</p>
        <p>
          <span className="text-primary font-bold">@Ana</span> definiu que o orçamento de marketing será aprovado até sexta.
        </p>
        <p className="mt-2">
          <span className="text-primary font-bold">@Carlos</span> ficou responsável por atualizar o deck de vendas com os novos números.
        </p>
      </div>
      
      <div className="p-4 border-t border-subtle bg-subtle/30 flex justify-end">
        <div className="px-4 py-2 bg-ink text-white text-xs font-bold rounded-lg shadow-sm">
          Gerar Brief
        </div>
      </div>
    </div>
  );
};